// install global components from this folder
// not all components need to be installed this way!!
import WnPages from './WnPages.vue'
import WnTablePages from './WnTablePages.vue'
import WnDropDown from './WnDropDown.vue'
import WnChoices from './WnChoices.vue'
import WnUpload from './WnUpload.vue'
import WnFileList from './WnFileList.vue'
import PlaceHolder from './PlaceHolder.vue'

const components = {
	WnPages,
    WnTablePages,
    WnDropDown,
	WnChoices,
	WnUpload,
	WnFileList,
	PlaceHolder,
}

export default {
	install(app) {
		Object.keys(components).forEach((name) => {
			const component = components[name];
			app.component(name, component);
		})
	}
}